// removed by extract-text-webpack-plugin
module.exports = {"realtorsAssociationWrap":"_27KAlpqUoE7NzuH1NH8jZx","topWrap":"_5k74kPTUQVMHHMwI5Flzi","bgCover":"AWEIyferUL983kbYyL92q","container":"ZuWVtfZMMVls_9pHKOzkM","logo":"BTwmqeUAB3hj7uHyYdmt2","content":"_1jPoepyCVWjVRIg_0FokIN","title":"_1QyEp0fs02TlaPUrhjYp6L","infoMessage":"_1PkdxDpC2_Bhozx6NHkYoI","description":"_1uMM-8QADiUvivTR_TebBP","descriptionMain":"_3EHFjPxIkXxR5IBMp2Xsl7","descriptionTitle":"_1EMGIatvR7xJ3kZ0JgOmjR","listBlock":"kTMM2yZreV2Lij0pk3Ka2"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorsAssociationContainer/RealtorsAssociationContainer.scss
// module id = 1852
// module chunks = 0